<dx-popup
  [width]="600"
  [height]="500"
  [showTitle]="true"
  title="Kreiraj SMS potražnju"
  [(visible)]="isVisible"
  [dragEnabled]="false"
  [closeOnOutsideClick]="false"
  (onHiding)="onPopupHiding()"
  (onShown)="onPopupShown()">

  <div *dxTemplate="let options of 'content'" class="popup-content-wrapper">
    <div *ngIf="dataLoading" class="data-loading">
      <dx-load-indicator size="small"></dx-load-indicator>
      <span>Učitavanje podataka...</span>
    </div>

    <div class="form-container" [class.loading]="dataLoading">
      <dx-form
        [formData]="smsPotraznjaForm.value"
        (onFieldDataChanged)="onFieldDataChanged($event)"
        [readOnly]="false"
        [showColonAfterLabel]="true"
        labelLocation="top"
        class="custom-form">
        
        <dxi-item 
          dataField="id_firme" 
          editorType="dxSelectBox" 
          [editorOptions]="firmaEditorOptions"
          label="Firma">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>
        
        <dxi-item 
          dataField="drzava" 
          editorType="dxSelectBox" 
          [editorOptions]="drzavaEditorOptions"
          label="Država">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>
        
        <dxi-item 
          dataField="tekst" 
          editorType="dxTextArea" 
          [editorOptions]="tekstEditorOptions"
          label="Tekst potražnje">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>

        <!-- Hidden valuta field that gets auto-populated -->
        <dxi-item 
          [visible]="false"
          dataField="valuta" 
          editorType="dxTextBox" 
          [editorOptions]="valutaEditorOptions"
          label="Valuta (automatski)">
        </dxi-item>

      </dx-form>

      <!-- Form Actions -->
      <div class="form-actions">
        <dx-button
          text="Otkaži"
          stylingMode="contained"
          type="default"
          (onClick)="onCancel()"
          class="action-button">
        </dx-button>
        
        <dx-button
          text="Kreiraj potražnju"
          stylingMode="contained"
          type="default"
          [disabled]="!smsPotraznjaForm.valid"
          (onClick)="onSubmit()"
          class="action-button">
        </dx-button>
      </div>
    </div>
  </div>
</dx-popup>

<dx-load-panel
  [visible]="loading"
  [showPane]="true"
  [shading]="true"
  shadingColor="rgba(0, 0, 0, 0.4)">
</dx-load-panel>